import { render, staticRenderFns } from "./PostulatedProjectsTable.vue?vue&type=template&id=3e54383e&scoped=true"
import script from "./PostulatedProjectsTable.vue?vue&type=script&lang=js"
export * from "./PostulatedProjectsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e54383e",
  null
  
)

export default component.exports